import { render, staticRenderFns } from "./CoinsSelector.vue?vue&type=template&id=3bee43d0&scoped=true&"
import script from "./CoinsSelector.vue?vue&type=script&lang=js&"
export * from "./CoinsSelector.vue?vue&type=script&lang=js&"
import style0 from "./CoinsSelector.vue?vue&type=style&index=0&id=3bee43d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bee43d0",
  null
  
)

export default component.exports